import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import HeaderDatePicker from './header-datepicker';

const StyledHeaderCalendar = styled.div`
  border-bottom: 1px solid #90a2b2;
  background-color: #f7f9fb;
  height: 40px;
`;

const HeaderCalendar = ({
  dateReference,
  view,
  setDateReference,
  setViewWorkingDays,
}) =>
  <StyledHeaderCalendar>
    <HeaderDatePicker
      dateReference={dateReference}
      view={view}
      setDateReference={setDateReference}
      setViewWorkingDays={setViewWorkingDays}
    />
  </StyledHeaderCalendar>;
HeaderCalendar.propTypes = {
  dateReference: PropTypes.object,
  view: PropTypes.object,
  setDateReference: PropTypes.func,
  setViewWorkingDays: PropTypes.func,
};

export default HeaderCalendar;
